/**
 * Load the baked Inter subsets once; canvas text must wait for this. Besides the weights every
 * label is set in, a label's own words may be bolder (800) or italic (2026-10-28: rich text).
 */
const FACES: [number, string, boolean][] = [
  [500, '/fonts/MapMarkInter-500.woff2', false],
  [600, '/fonts/MapMarkInter-600.woff2', false],
  [700, '/fonts/MapMarkInter-700.woff2', false],
  [800, '/fonts/MapMarkInter-800.woff2', false],
  [600, '/fonts/MapMarkInter-600i.woff2', true],
  [700, '/fonts/MapMarkInter-700i.woff2', true],
  [800, '/fonts/MapMarkInter-800i.woff2', true],
];

let loading: Promise<void> | null = null;

export function loadFonts(): Promise<void> {
  if (loading) return loading;
  loading = (async () => {
    if (typeof FontFace === 'undefined' || !document.fonts) return;
    await Promise.all(
      FACES.map(async ([weight, url, italic]) => {
        const face = new FontFace('MapMark Inter', `url(${url}) format("woff2")`, { weight: String(weight), style: italic ? 'italic' : 'normal', display: 'swap' });
        try {
          await face.load();
          document.fonts.add(face);
        } catch (e) {
          console.warn('font load failed', url, e);
        }
      }),
    );
  })();
  return loading;
}
